import { inject, Injectable } from '@angular/core';
import { NavigationError, NavigationStart, Router } from '@angular/router';
import { SharedCacheService } from '@raxshared/cache.service';
import { filter, Subscription } from 'rxjs';
import { ICachedState } from './ICachedState';

@Injectable({
    providedIn: 'root',
})
export class RouterEventSubscriptions {
    private readonly router = inject(Router);
    private readonly cacheService = inject(SharedCacheService);

    private redirectToLoadingSubscription?: Subscription;

    public redirectToLoadingOnFirstPageLoad(): void {
        this.redirectToLoadingSubscription = this.router.events
            .pipe(filter((routerEvent) => routerEvent instanceof NavigationStart))
            .subscribe((navigationStartEvent) => {
                if (
                    navigationStartEvent.url.startsWith('/auth') ||
                    navigationStartEvent.url === '/auth' ||
                    navigationStartEvent.url === '/error' ||
                    navigationStartEvent.url === '/login' ||
                    navigationStartEvent.url === '/logout' ||
                    navigationStartEvent.url === '/loginFailed' ||
                    navigationStartEvent.url === '/loading'
                ) {
                    this.redirectToLoadingSubscription?.unsubscribe();
                    return;
                }

                if (navigationStartEvent.url !== '/loading' && navigationStartEvent.url !== '/') {
                    this.cacheService.addMemory<ICachedState>('stateToLoad', {
                        url: navigationStartEvent.url,
                    });
                }

                this.router.navigateByUrl('loading');
                this.redirectToLoadingSubscription?.unsubscribe();
            });
    }

    public logNavigationError(): void {
        this.router.events.pipe(filter((e) => e instanceof NavigationError)).subscribe((e) => {
            console.log('Navigation error: ', e);
        });
    }
}
